import {AppSettings} from "../../shared/AppSettings";
import Vue from 'vue';
import authService from "../../core/services/auth.service";

class SocketService {
  currentListeners = {};

  async connect() {
    await Vue.prototype.$connect(AppSettings.getWsUrl() + `?token=${authService.getToken()}`);
    // this.initGlobalListener();
  }

  async disconnect() {
    await Vue.prototype.$disconnect()
  }

  initGlobalListener() {
    Vue.prototype.$socket.onmessage = (response) => {
      console.log("onmessage from initGlobalListener");
      let data = JSON.parse(response.data);

      for (let name in this.currentListeners) {
        let split = name.split('.');

        if (split[1] && split[1] === data.action) {
          if (typeof data.data === 'string') {
            this.currentListeners[name](JSON.parse(data.data));
          } else {
            this.currentListeners[name](data.data);
          }
        }
      }
    };
  }

  sendObj(data, action) {
    Vue.prototype.$socket.sendObj({data, action})
  }

  listen(name, handler) {
    if (name.split('.').length !== 2) {
      console.error('Please provide correct listener name for ws (dot-separated)')
    } else {
      this.currentListeners[name] = handler;
    }
  }

  remove(name) {
    if (this.currentListeners[name]) {
      delete this.currentListeners[name];
    }
  }
}

Vue.prototype.$ws = new SocketService();
